"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f601 = void 0;
exports.f601 = {
    "əblam əbkuo": [
        5887
    ],
    "əblam": [
        5887
    ],
    "əbkuo": [
        5887
    ],
    "əs-saare": [
        8020
    ],
    "ət-hun": [
        8024
    ]
};
